import React from 'react';
import { withFormulas } from '../hocs/with-formulas';
import { ScoreContent, ScoreSubcomponents } from '../components';


export const ScoreScalability = ({formulas, className}) => {
  const costTitle = "Scalability";
  const costSummary = "The scalability of your AR operation is a key component of overall health. It measures the agility and readiness of your business to adapt to sudden changes in volume, payments, or economic conditions."
  const getStarted = () => {
    window.open('https://www.paystand.com/ar-health-consult','_blank','resizable=yes');
  }
  return (
    <ScoreContent title={costTitle} summary={costSummary} className={className}>
      <div className="print--only-visible">
        <img src={require(`../../styles/img/${formulas.getScalabilityScore()}_score.png`)} style={{width: "55px"}} alt="score-a"/>
      </div>
      <div className="health-graph">
        <ScoreSubcomponents title="Manual to Automation Spectrum" health={formulas.getAutomatationSpectrumHealth()}/>
        <ScoreSubcomponents title="Minutes spent per invoice" health={formulas.getMinutesPerInvoiceHealth()}/>
        <ScoreSubcomponents title="Relationship between AR costs to revenue" health={formulas.getArCostRevenueHealth()}/>
      </div>
      <div className="info">
        <span className="text-02-navy-blue">Recommended Reading</span>
        <p className="text-04-navy-blue-bold">Here are some helpful resources for understanding how to create an automated, scalable payment process.</p>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/4-accounts-receivable-processes-every-controller-should-automate-in-2020" target="_blank" rel="noopener noreferrer">
          4 AR Processes to Automate in 2020
        </a>
        <a className="text-04-sky-blue" href="https://www.paystand.com/blog/how-to-start-automating-accounts-receivable-process" target="_blank" rel="noopener noreferrer">
          How to Start Automating AR
        </a>
        <a  className="text-04-sky-blue" href="https://www.paystand.com/resources/whitepapers/controllers-guide-b2b-payment-optimization" target="_blank" rel="noopener noreferrer">
          Guide To B2B Payment Optimization
        </a>
        <span className="text-02-navy-blue-bold">Ready to build a more scalable, growth-oriented payment process?</span>
        <button className={getStarted}>Schedule A Consult</button>
      </div>
    </ScoreContent>
  )
}

export const ScoreScalabilityWithFormulas = withFormulas(ScoreScalability);